import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/layout'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: layout,
    children: [
      {
        path: '/universities',
        name: 'universities',
        component: () => import('@/views/universities/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  // mode: 'hash',
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach(async (to, from, next) => {
//   console.log(111)
//   next()
// })

export default router
